import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerApiRequest } from '../ticket-manager.api';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

export const buildGetProjectRootCauseGroupsRequest = ({
  projectId,
}: {
  projectId: string;
}): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/root_cause_groups`,
});

export const buildGetProjectRootCausesRequest = ({ projectId }: { projectId: string }): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/root_causes/`,
});

export const buildGetRootCauseGroupRootCausesRequest = ({
  projectId,
  rootCauseGroupId,
}: {
  projectId: string;
  rootCauseGroupId: string;
}): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/root_cause_groups/${rootCauseGroupId}/root_causes`,
});

export const buildCreateRootCauseGroupRequest = ({
  name,
  projectId,
}: {
  name: string;
  projectId: string;
}): TicketManagerApiRequest => ({
  data: {
    name,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/root_cause_groups`,
});

export const buildUpdateRootCauseGroupRequest = ({
  name,
  projectId,
  rootCauseGroupId,
}: {
  name: string;
  projectId: string;
  rootCauseGroupId: string;
}): TicketManagerApiRequest => ({
  data: {
    name,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/root_cause_groups/${rootCauseGroupId}/update`,
});

export const buildCreateRootCauseRequest = ({
  key,
  name,
  projectId,
}: {
  key: string;
  name: string;
  projectId: string;
}): TicketManagerApiRequest => ({
  data: {
    key,
    name,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/root_causes`,
});

export const buildAddRootCauseToGroupRequest = ({
  projectId,
  rootCauseGroupId,
  rootCauseId,
}: {
  projectId: string;
  rootCauseGroupId: string;
  rootCauseId: string;
}): TicketManagerApiRequest => ({
  data: {
    root_cause_id: rootCauseId,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/root_cause_groups/${rootCauseGroupId}/add_root_cause`,
});

export const buildRemoveRootCauseFromGroupRequest = ({
  projectId,
  rootCauseGroupId,
  rootCauseId,
}: {
  projectId: string;
  rootCauseGroupId: string;
  rootCauseId: string;
}): TicketManagerApiRequest => ({
  data: {
    root_cause_id: rootCauseId,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/root_cause_groups/${rootCauseGroupId}/root_causes/${rootCauseId}/delete`,
});
